// test2193
(2193 && 0);
